export const SEVERITY_COLORS: Record<string, string> = {
  critical: '#ef4444',
  warning: '#f59e0b',
  success: '#10b981',
  good: '#10b981',
  info: '#0ea5e9',
};

// Base scales by placement type — matched to city tile scale (30)
export const MODEL_SCALES: Record<string, number> = {
  infrastructure: 25,
  residential: 18,
  commercial: 15,
  streetworks: 12,
  underground: 10,
  community: 20,
};

export const MODEL_SCALE_OVERRIDES: Record<string, number> = {};

// City grid: each cell = 30 meters in world space
export const TILE_WORLD_SCALE = 30;

// ─── Chunk streaming ────────────────────────────────────────────────────────
// Only city chunks within the viewport (+margin) are added to the scene; the
// rest are recycled out as the user pans. Extra world-unit margin so chunks
// are built slightly before they scroll into view (avoids pop-in).
export const CHUNK_VISIBILITY_MARGIN = 450;

// Kenney road at TILE_WORLD_SCALE=30 has 2 lanes, each ~15 units wide.
// Simpoly trucks are ~2.5 units internally. Scale 3.5 → ~9 units = visible in lane.
export const VEHICLE_SCALE = 5;

// Simpoly models face -X natively → rotate +π/2 to face +Z
// Kenney models face -Z natively → rotate +π to face +Z
export const MODEL_ROTATION_OFFSET: Record<string, number> = {
  'simpoly-tanker': Math.PI / 2,
  'simpoly-tanker2': Math.PI / 2,
  'simpoly-dump': Math.PI / 2,
  'simpoly-pickup': Math.PI / 2,
  'simpoly-semi': Math.PI / 2,
  'simpoly-mixer': Math.PI / 2,
  'kenney-sedan': 0,
  'kenney-suv': 0,
  'kenney-taxi': 0,
  'kenney-van': 0,
  'kenney-delivery': 0,
  'kenney-truck': 0,
  'kenney-truck-flat': 0,
  'kenney-firetruck': 0,
  'kenney-garbage-truck': 0,
  'kenney-police': 0,
};

// Per-model scale overrides (kenney cars need different scale than simpoly trucks)
export const VEHICLE_SCALE_OVERRIDE: Record<string, number> = {
  'kenney-sedan': 5.5,
  'kenney-suv': 5.5,
  'kenney-taxi': 5.5,
  'kenney-van': 5.0,
  'kenney-delivery': 4.5,
  'kenney-truck': 5.0,
  'kenney-truck-flat': 5.0,
  'kenney-firetruck': 4.5,
  'kenney-garbage-truck': 4.5,
  'kenney-police': 5.5,
};

export const VEHICLE_MODEL_IDS = [
  'simpoly-tanker', 'simpoly-tanker2', 'simpoly-dump',
  'simpoly-pickup', 'simpoly-semi', 'simpoly-mixer',
  'kenney-sedan', 'kenney-suv', 'kenney-taxi', 'kenney-van',
  'kenney-delivery', 'kenney-truck', 'kenney-truck-flat',
  'kenney-firetruck', 'kenney-garbage-truck', 'kenney-police',
];

// Subset of VEHICLE_MODEL_IDS for ambient road-wandering traffic — civilian
// cars + light pickup, no heavy/emergency models. All ids must stay a subset
// of VEHICLE_MODEL_IDS so VehicleSystem.preload covers them.
export const AMBIENT_TRAFFIC_MODEL_IDS = [
  'kenney-sedan', 'kenney-suv', 'kenney-taxi', 'kenney-van',
  'kenney-delivery', 'kenney-truck', 'simpoly-pickup',
];

export const CLUTTER_LAYERS = [
  'markers-3d', 'markers-ground-glow', 'markers-pulse-ring',
  'markers-labels', 'markers-crews',
];

export const NETWORK_LAYERS = [
  'water-mains', 'gas-mains', 'sewer-lines', 'electric-cables',
  'water-mains-glow', 'gas-mains-glow', 'sewer-lines-glow', 'electric-cables-glow',
];

export const AUTHORITY_LAYERS = [
  'authority-boundaries', 'authority-boundaries-outline', 'authority-labels',
];

export const FOG_DEFAULT = {
  color: '#030508',
  'high-color': '#050a10',
  'horizon-blend': 0.08,
  'space-color': '#000000',
  'star-intensity': 0.15,
} as const;

export const FOG_STORM = {
  color: '#030609',
  'high-color': '#040608',
  'horizon-blend': 0.5,
  'space-color': '#000000',
  'star-intensity': 0,
} as const;
